export default "__VITE_ASSET__CamQd1z0__"